import { openInNewCard } from "helpers/routing";
import { formatPrice } from "helpers/subscription";
import { RecurlyCouponType } from "store/entities/recurly";
import { BillingCycle, Plan } from "store/entities/subscriptions";

interface ICoupon {
  type: "dollars" | "percent";
  value: number;
}

export const redirectToSalesTaxHelpCenter = (): void => openInNewCard("https://www.livechat.com/help/sales-tax/");

export const getCouponText = (coupon: ICoupon): string => {
  const { type, value } = coupon;

  if (type === RecurlyCouponType.Dollars) {
    return `Discount ${formatPrice(value / 100)}`;
  }
  return `Discount ${value}%`;
};

export function preparePlanCode(plan: Plan, billingCycle: BillingCycle): string {
  return `hd-${plan}${billingCycle}m`;
}
